import React from 'react';
import { useDispatch } from 'react-redux';
import { grey } from '@mui/material/colors';
import { SwitchField } from 'components/form';
import makeStyles from '@mui/styles/makeStyles';
import { HelpOutline } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import { Box, Tooltip, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { deskingActions } from '../../../model';
import { BuilderViewType, FinanceProgramFormValues } from '../../../types';

interface Props {
  isSupportBehaviorSetting: boolean;
  menuBuilderViewType: BuilderViewType;
}

export const ProposalSettings = ({ menuBuilderViewType, isSupportBehaviorSetting }: Props) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { control } = useFormContext<FinanceProgramFormValues>();

  return (
    <Box className={classes.container}>
      <Box className="panel">
        <Typography component="span" variant="subtitle2">
          Proposal Settings
        </Typography>

        <Tooltip placement="top" arrow title="Control which elements of the menu appear for the customer">
          <HelpOutline fontSize="small" />
        </Tooltip>
      </Box>

      <Box className="form">
        <RenderWithCondition condition={menuBuilderViewType === BuilderViewType.AftermarketMenu}>
          <>
            <SwitchField
              control={control}
              name="displaySettings.excludeEquipmentSales"
              label="Exclude Equipment Sales from Menu Calculations"
              extraAction={() => {
                dispatch(deskingActions.updateRecalculate());
              }}
            />

            <SwitchField control={control} name="displaySettings.productDetails" label="Show Product Details" />
            <SwitchField control={control} name="displaySettings.productPrice" label="Show Product Price" />
          </>
        </RenderWithCondition>

        <RenderWithCondition condition={menuBuilderViewType === BuilderViewType.Finance}>
          <>
            <SwitchField control={control} name="displaySettings.showBestOptions" label="Show Best Options" />
            <SwitchField control={control} name="displaySettings.showLenderLogo" label="Show Lender Logo" />
            <SwitchField control={control} name="displaySettings.showLenderName" label="Show Lender Name" />
            <SwitchField control={control} name="displaySettings.showInterestRate" label="Show Interest Rate" />
          </>
        </RenderWithCondition>

        <RenderWithCondition condition={isSupportBehaviorSetting}>
          <SwitchField control={control} name="displaySettings.shouldRedirectToOCA" label="Send Credit App" />
        </RenderWithCondition>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    gap: '12px',
    display: 'flex',
    flexDirection: 'column',

    '& .panel': {
      gap: '0.5rem',
      padding: '8px',
      display: 'flex',
      borderRadius: '2px',
      alignItems: 'center',
      backgroundColor: grey['A100'],
    },

    '& .form': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
});
